import React, {useEffect, useState} from "react";
import Preloader from "../preloader/preloader";
import api from "../../../dataAccessLayer/firebase";
import Chart from "react-apexcharts";
import {NavLink} from "react-router-dom";

//импорт стилей
import './advView.scss';
import leftArrow from "../../../assets/slider-svg/left-arrow.svg";
import rightArrow from "../../../assets/slider-svg/right-arrow.svg";
import { BsArrowsFullscreen } from "react-icons/bs"





const AdvViewContainer = props => {
   const {id} = props.match.params
    //console.log(id);

    const [currentAdv, setCurrentAdv] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [mainPhotoIndex, setMainPhotoIndex] = useState(0);
    const [priceHistory, setPriceHistory] = useState([]);
    const [position, setPosition] = useState(0);


    useEffect( () => {
        if (!isLoading) {

            api.getAdvById(id).then(res => {
                let aditionalPriceHistory
                setCurrentAdv(res)
                setIsLoading(true)
                aditionalPriceHistory = res.priceHistory.map(item => {
                    return ({x: item.date.toDate().getTime(), y: Number(item.price)})
                })
                console.log(aditionalPriceHistory)

                setPriceHistory(  aditionalPriceHistory)
                console.log(priceHistory)
            })

          // let additionalPriceHistory = currentAdv.priceHistory.map(item =>  return ({x:historyItem.date.toDate(), y:historyItem.price}))
        }
    }, [api.getAdvById] )





    const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timezone: 'UTC',
        hour: 'numeric',
        minute: 'numeric'
    };


    const chartState = {
        options: {
            chart: {
                id: "basic-bar"
            },
            stroke: {
                curve: 'smooth',
            },
            xaxis: {
                type: 'datetime'
            }
        },
        series: [
            {
                name: "Цена",
                data: priceHistory
            }
        ]
    };

      return(!isLoading
          ? <Preloader/>
          :
              <div className="item">
                  <NavLink to='/'>
                      <div className="date">
                          Недвижимость в Москве
                      </div>
                  </NavLink>
                  <div className="date">
                      {`${currentAdv.date.toDate().toLocaleString("ru", dateOptions)}`}
                  </div>

                  <div className="field">

                      <div className="content">
                          <div className="infoSection" >
                              <div className="infoSectionItem">
                                  <h3>{`${currentAdv.rooms} ` }</h3> <h4>   комн. квартира</h4><h3>{`${currentAdv.square} `}</h3> <h4>м2</h4>
                              </div>
                              <div className="infoSectionItem">
                                  <h3>{`${currentAdv.floor}  `}</h3> <h4>этаж</h4>
                              </div>
                              <div className="infoSectionItem">{currentAdv.address} </div>


                          </div>

                          <div className="sliderContainer">
                              <div className="sliderBox">
                                  <div className="left__slider">
                                      <img onClick={() => {
                                          if (mainPhotoIndex > 0) {
                                              setMainPhotoIndex(mainPhotoIndex - 1)
                                          }
                                      }} className="leftArrow" src={leftArrow} alt={"leftArrow"}/>
                                  </div>
                                  <img className="mainPhoto"
                                       src={currentAdv.imgUrl[mainPhotoIndex] ? currentAdv.imgUrl[mainPhotoIndex] : null}
                                       alt={currentAdv.address}/>
                                  <div className="right__slider">
                                      <img onClick={() => {
                                          if (mainPhotoIndex < currentAdv.imgUrl.length-1) {
                                              setMainPhotoIndex(mainPhotoIndex + 1)
                                          }
                                      }}
                                           className="rightArrow" src={rightArrow} alt={"rightArrow"}/>
                                  </div>
                                  <div className="extender">
                                      <BsArrowsFullscreen/>
                                  </div>
                              </div>

                              <div className="smallPhotos">
                                  {currentAdv.imgUrl
                                      ? currentAdv.imgUrl.map((item, index, array) => {
                                          //if (index >= mainPhotoIndex - 2 && index <= mainPhotoIndex + 4) {
                                              return (
                                                  <div
                                                      className={"smallPhotoItems" + " " + (index === mainPhotoIndex && "activeSmallPhotoItems")}

                                                  >
                                                      <img src={item}
                                                           alt="advPhotos"
                                                           style={{left: `${position} px`}}
                                                           onClick={() => {
                                                               setPosition(110)
                                                               console.log(position)
                                                               setMainPhotoIndex(index)

                                                           }}
                                                      />
                                                  </div>
                                              )
                                          //}
                                      })
                                      : null}
                              </div>
                          </div>
                          <div className="advInfo" >
                              <h3>Описание</h3>
                              {`${currentAdv.description}`}
                              <div><h4>{`+7 ${currentAdv.phone}`}</h4></div>
                          </div>



                      </div>


                      <div className="chart">
                          <div><h3>{`${currentAdv.price} руб`}</h3></div>
                          История цены
                          <Chart
                              options={chartState.options}
                              series={chartState.series}
                              type="line"
                              width="500px"

                          />
                      </div>
                  </div>
              </div>
    )

}

export default AdvViewContainer